import { getCookie } from 'typescript-cookie'
import { StateCreator, create } from 'zustand'
import { devtools } from 'zustand/middleware'

export interface EmptyStateStore {
  isFirstLogin: boolean
  shouldRender: boolean
  sessionStatus: boolean
  oldToken: string
  finishedLoading: boolean
  showTempData: boolean
  disableInteractions: boolean
  isQueriesDashboardCompleted: { [key: string]: boolean }
  setIsFirstLogin: (status: boolean) => void
  setShouldRender: (status: boolean) => void
  setSessionStatus: (status: boolean) => void
  setOldToken: (token: string) => void
  setFinishedLoading: (status: boolean) => void
  setShowTempData: (status: boolean) => void
  showPmDashboard: (update: { [key: string]: boolean }) => void
  setDisableInteractions: (status: boolean) => void
}

const emptyStateStore = (set: (fn: (state: EmptyStateStore) => EmptyStateStore) => void) => ({
  isFirstLogin: false,
  shouldRender: true,
  sessionStatus: false,
  showTempData: false,
  oldToken: getCookie('jwtToken') || '',
  isQueriesDashboardCompleted: {},
  finishedLoading: false,
  disableInteractions: false,
  setIsFirstLogin: (status: boolean) => {
    set((state: EmptyStateStore) => ({
      ...state,
      isFirstLogin: status,
    }))
  },
  setShouldRender: (status: boolean) => {
    set((state: EmptyStateStore) => ({
      ...state,
      shouldRender: status,
    }))
  },
  setSessionStatus: (status: boolean) => {
    set((state: EmptyStateStore) => ({
      ...state,
      sessionStatus: status,
    }))
  },
  setOldToken: (token: string) => {
    set((state: EmptyStateStore) => ({ ...state, oldToken: token }))
  },
  setFinishedLoading: (status: boolean) => {
    set((state: EmptyStateStore) => ({ ...state, finishedLoading: status }))
  },
  setShowTempData: (status: boolean) => {
    set((state: EmptyStateStore) => ({ ...state, showTempData: status }))
  },
  showPmDashboard: (update: { [key: string]: boolean }) => {
    set((state: EmptyStateStore) => ({
      ...state,
      isQueriesDashboardCompleted: {
        ...state.isQueriesDashboardCompleted,
        ...update,
      },
    }))
  },
  setDisableInteractions: (status: boolean) => {
    set((state: EmptyStateStore) => ({ ...state, disableInteractions: status }))
  },
})

export const useEmptyStateStore = create<EmptyStateStore>()(
  devtools(
    emptyStateStore as StateCreator<
      EmptyStateStore,
      [['zustand/devtools', never]],
      [],
      EmptyStateStore
    >
  )
)
export default useEmptyStateStore
